


















































import { Component, Mixins, Prop } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Types
import { IInvoice } from "@/models/invoices";

@Component({
  components: {
    "invoice-provider": () =>
      import("@/components/app/global/invoices/invoiceProvider.vue"),
    "invoice-items": () =>
      import("@/components/app/global/invoices/invoiceItems.vue")
  }
})
export default class BasketPreviewModal extends Mixins(RequestPromises) {
  // Props
  @Prop({ required: true })
  public invoiceId!: IInvoice["id"];
}
